import { render, staticRenderFns } from "./create-user.vue?vue&type=template&id=46915c9f"
import script from "./create-user.vue?vue&type=script&lang=ts"
export * from "./create-user.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports